export default __webpack_public_path__ + "static/media/videoplayback.6291f71f.mp4";